const StorageKey = {
  SIDEBAR: 'sidebar',
  TOKEN: 'token',
  PARTNER_TOKEN: 'partner_token',
  IS_PARTNER_LOGIN: 'is_partner_login',
  PARTNER_DATA: 'partnerData',
} as const;

export { StorageKey };
